<div class="layout-topbar">
  @let config = (config$ | async)!;
  <div class="topbar-left">
    @let user = (user$ | async)!;
    <a tabindex="0" class="menu-button p-trigger" (click)="toggleSidebarMode()" (keydown.enter)="toggleSidebarMode()">
      <i [class]="isCompact(config) ? 'fa fa-chevron-right' : 'fa fa-chevron-left'"></i>
    </a>
    <span class="topbar-separator my-2"></span>
    <app-breadcrumb></app-breadcrumb>
    <div class="grow"></div>

    @if (isUserInMaster && haveUserReadOnlyRoleForMasterData(user)) {
      <span class="mr-6 flex items-center gap-2">
        <i>{{ 'general.readOnly' | translate }}</i>
        <fa-icon [icon]="faEye"></fa-icon>
      </span>
    }

    @if (loadedWikiPage) {
      <button pButton type="button" (click)="openWiki()" size="small" [disabled]="loadingWiki()" class="pr-2" iconOnly>
        @if (loadingWiki()) {
          <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
        } @else {
          <fa-icon [icon]="faQuestion"></fa-icon>
        }
      </button>
    }

    @if (showEnvironmentTile) {
      <div
        class="mx-4 flex items-center justify-center rounded-full px-3 py-2 text-center text-xs font-bold tracking-wide shadow-sm ring-1 ring-black/10 ring-inset"
        [class]="environmentColorClasses"
      >
        {{ environment | uppercase }}
      </div>
    }

    <img class="mobile-logo" [src]="logoSrc" alt="RGS+" />
  </div>

  <app-sidebar></app-sidebar>
  <div class="layout-mask modal-in"></div>

  <div class="topbar-right">
    <ul class="topbar-menu">
      <li class="profile-item">
        <button
          type="button"
          id="topbarProfileTrigger"
          class="topbar-profile-trigger flex gap-2 p-2"
          aria-haspopup="menu"
          aria-controls="topbarProfileMenu_list"
          [attr.aria-expanded]="menuOpen()"
          (click)="profileMenu.toggle($event)"
        >
          <p-avatar [label]="username()" shape="circle"></p-avatar>
          <span class="profile-name">{{ activeLicenseLabel() }}</span>
          <i class="fa fa-chevron-down text-xs"></i>
        </button>

        <p-menu
          #profileMenu
          id="topbarProfileMenu"
          [popup]="true"
          appendTo="body"
          [model]="profileMenuItems()"
          styleClass="topbar-profile-menu"
          ariaLabelledBy="topbarProfileTrigger"
          [(expandedKeys)]="licenseExpandedKeys"
          (onShow)="menuOpen.set(true)"
          (onHide)="menuOpen.set(false); collapseLicenses()"
        ></p-menu>
      </li>
    </ul>
  </div>
</div>
<app-notifications-sidebar #notificationsSidebar></app-notifications-sidebar>
<app-tasks-sidebar #tasksSidebar></app-tasks-sidebar>
